import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { Avatar, AvatarProps, Tooltip } from '@fluentui/react-components'

type Props = AvatarProps & { tooltip?: boolean }

export default function PersonAvatar(props: PropsWithChildren<Props>): ReactElement {
    if (props.tooltip === false) {
        return <Avatar {...props} />
    }

    return (
        <Tooltip relationship={'label'} content={props.name} withArrow>
            <Avatar {...props} />
        </Tooltip>
    )
}
